export default {"src":"/_next/static/media/music-off.457cbbd9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};